const Logger = require('../../util/logger_utils');

const DEFAULT_LANGUAGE = 'en';

export default {
    setLanguage(lang) {
        this.lang = lang;
        this._setKeysForLanguage(lang);
    },

    isInitialized() {
        return !!this.lang;
    },

    /**
     *
     * @param {string} key the key to look for in the dictionary files
     * @param {Object} [options]
     * @param {String} [options.language], 2 letter representation of the language, e.g. 'en'
     * @return {*}
     */
    get(key, options) {
        if (!key) throw Error('key is required');
        options = options || {};

        // Set language
        if (options.language) {
            this._setKeysForLanguage(options.language);
        } else if (!this.isInitialized()) {
            console.debug('language keys available', this.keys);
            Logger.warn(`Defaulting to '${DEFAULT_LANGUAGE}' as no language is set yet`);
            this.setLanguage(DEFAULT_LANGUAGE);
        }

        const value = this.keys && this.keys[this.lang] && this.keys[this.lang][key];
        if (!value) {
            Logger.warn(`Language key ${key} was not found for language ${this.lang}. The key itself has been returned`);
            return key;
        }
        return value;
    },

    tripluralSeason(phrase, num, lang='en', arrangement='post') {

        const textDisplayOptionList = {
            'pre' : 'phrase' + ' ' +  'num',
            'post' : 'num' + ' ' +  'phrase',
            'none' : 'phrase'
        };

        const vars = {
            'phrase': phrase.trim(),
            'num': num.trim()
        };
        
        if (lang === 'ar') {
            vars.num = num;
            // Unusual case of AR
            if (parseInt(num) === 2) { // If number of season are 2
                // موسمان
                arrangement = 'none';
                vars.phrase = this.get('season2');
            } else if (parseInt(num) >= 3) { // If number of season are 3
                // ٣ مواسم
                arrangement = 'post';
                vars.phrase = this.get('season3');
                if (parseInt(num) > 10) {
                    vars.phrase = this.get('season1');
                } else {
                    vars.phrase = this.get('season3');
                }
            } else {
                //  موسم ١
                arrangement = 'pre';
                vars.phrase = this.get('season1');
            }
        }

        let pluralised = textDisplayOptionList[arrangement].replace('phrase', vars.phrase);
        return pluralised.replace('num', vars.num);
    },

    _setKeysForLanguage(language) {
        this.keys = this.keys || {};
        if (this.keys[language]) return; // Language keys already set
        this.keys[language] = require(`../../dict/${language}/${language}.js`);
    },

    defaultKeys: require(`../../dict/${DEFAULT_LANGUAGE}/${DEFAULT_LANGUAGE}.js`)
};



// WEBPACK FOOTER //
// ./src/modules/language_manager/language_manager.js